import * as React from 'react'
import {connect} from "react-redux";
import logo from '../../images/logo_black.svg'
import './index.scss'
import nullIcon from '../../images/null_icon.svg'
import {injectIntl, IntlShape} from "react-intl";
import {NavLink} from "react-router-dom";

interface IProps {
    intl: IntlShape
}

class NoMatch extends React.Component<IProps, {}> {
    public render() {
        let {intl} = this.props
        return (
            <div className="noMatch">
                <div className="topBar">
                    <NavLink to='/'>
                        <img src={logo} alt="logo" className="logo"/>
                    </NavLink>
                </div>
                <div className="content">
                    <img src={nullIcon} alt="empty" className="nullIcon"/>
                    <h2>{intl.formatMessage({id: 'msg404'})}</h2>
                </div>
            </div>
        );
    }
}

export default injectIntl(connect()(NoMatch))